import { Component, OnInit, Output, EventEmitter, Input, TemplateRef, OnDestroy } from '@angular/core';
import { NavigationService } from '../../../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ITableColumnHeader } from '../../../../models/table-column-header';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../../providers/api.service';
import { SM_CONSTANTS } from '../../../../shared/constants/sm-constants';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { MatDialog } from '@angular/material/dialog';
import { BookingDetailsComponent } from 'src/app/shared/components/booking-details/booking-details.component';
import { InvoiceComponent } from 'src/app/shared/components/invoice/invoice.component';
import { MessagingService } from 'src/app/providers/messaging.service';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { AddFutureBookingsComponent } from 'src/app/shared/components/add-future-bookings/add-future-bookings.component';

@Component({
  selector: 'sm-tax-collection-report',
  templateUrl: './tax-collection-report.component.html',
  styleUrls: ['./tax-collection-report.component.scss']
})
export class TaxCollectionReportComponent implements OnInit, OnDestroy {
  isEntityForeign: string = localStorage.getItem(SM_CONSTANTS.IS_ENTITY_FOREIGN)!
  selectedFrequency: any = 2
  // frequencyOfView: any
  selectedView: any = 'Data'
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
 entityHashId: string = ''
  pageTitle: string = 'Booking History' ;
  @Input() pageSubTitle: string = '';
  @Input() showBackButton: boolean = false;
  @Input('buttonText') showButton: string = '';
  @Input()
  headerCustomTemplate!: TemplateRef<any>;
 
  fromDate:any = new Date();
  toDate:any = new Date();
  today: string = this.formatDate1(new Date())
  taxCollectionReportData: any[] = [];
  secondtaxCollectionReportData: any[] = [];
  finaltaxCollectionReportData: any[] = [];
  public loader: boolean = false;
  public visible: boolean = false;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant('tax_report.column_headers.month'),
      columnProperty: "month"
    },
    {
      columnName: this.translateService.instant('tax_report.column_headers.total'),
      columnProperty: "ttax"
    },
    {
      columnName: this.translateService.instant('tax_report.column_headers.gst'),
      columnProperty: "gcollection"
    },
    {
      columnName: this.translateService.instant('tax_report.column_headers.service'),
      columnProperty: "stax"
    },
    {
      columnName: this.translateService.instant('tax_report.column_headers.other'),
      columnProperty: "otax"
    },
    
  ];
  
  private _apiSubscription: Subscription;
  constructor(private _navService: NavigationService, private router: Router, private route: ActivatedRoute, private _apiService: ApiService, private loaderservice: LoaderServiceService, public _modelRef: MatDialog, private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging,private translateService: TranslateService) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_TAX_COLLECTION_REPORT){
        this.taxCollectionReportData = []
        if(true){
          this.taxCollectionReportData = resData.result ? resData.result : [] 
          this.taxCollectionReportData.forEach(item => {
            if(item.date){
              item.month = this.convertDateString(item.date)
            }

            item.ttax = `${item.currency_symbol}${item.total_tax.toFixed(2)}`
            item.stax = `${item.currency_symbol}${item.service_tax.toFixed(2)}`
            item.otax = `${item.currency_symbol}${item.other_tax.toFixed(2)}`
            item.gcollection = `${item.currency_symbol}${item.gst_collection.toFixed(2)}`
          });
          //graph assign
          this.graphData = {
            datasets: [
              {
              label: 'GST Collection',
              data: this.taxCollectionReportData.map(item => {
                    return item.gst_collection
                }),
              backgroundColor: this.getDistinctColor(0,3),  // Use the custom function for color
              borderColor: this.getDistinctColor(0,3),  // Use the custom function for color            
              borderWidth: 1,
              categoryPercentage: 0.5
            },
              {
              label: 'Service Tax',
              data: this.taxCollectionReportData.map(item => {
                    return item.service_tax
                }),
              backgroundColor: this.getDistinctColor(1,3),  // Use the custom function for color
              borderColor: this.getDistinctColor(1,3),  // Use the custom function for color            
              borderWidth: 1,
              categoryPercentage: 0.5
            },
              {
              label: 'Other Tax',
              data: this.taxCollectionReportData.map(item => {
                    return item.other_tax
                }),
              backgroundColor: this.getDistinctColor(2,3),  // Use the custom function for color
              borderColor: this.getDistinctColor(2,3),  // Use the custom function for color            
              borderWidth: 1,
              categoryPercentage: 0.5
            },
            ],
            labels: this.taxCollectionReportData.map(item => {
              return item.month
          })
      
        }
        }
        this.visible = true
        this.loaderservice.showLoader = false
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_COLLECTION_REPORT){
        this.taxCollectionReportData = []
        this.finaltaxCollectionReportData = []
        this.secondtaxCollectionReportData = []
        if(true){
          this.tableDisplayColumns = []
          
          this.taxCollectionReportData = resData.result ? resData.result : [] 
          if(this.taxCollectionReportData.length > 0){
            this.taxCollectionReportData = this.normalizeTaxData(this.taxCollectionReportData)
          }
          
          
          this.taxCollectionReportData.forEach(item => {
            if(item.date){
              item.month = this.convertDateString(item.date)
            }
          });

          this.taxCollectionReportData = this.mergeTaxes(this.taxCollectionReportData)
          
         // Generate column configuration
        this.tableDisplayColumns = this.generateColumns(this.taxCollectionReportData);

        // Map the rows for display
        this.finaltaxCollectionReportData = this.taxCollectionReportData.map(this.mapRowData);

        
        console.log(this.tableDisplayColumns); // Logs the columns
        console.log(this.finaltaxCollectionReportData); // Logs the rows with mapped values for taxes

          //graph assign
            // Prepare the months and tax names
        const months = this.taxCollectionReportData.map(item => item.month);
        const taxNames = this.taxCollectionReportData[0].taxes.map((tax:any) => tax.tax_name);

        // Prepare datasets for each tax
        const datasets = taxNames.map((taxName:any, index:any) => {
          return {
            label: taxName,
            data: this.taxCollectionReportData.map(item => {
              const tax = item.taxes.find((t:any) => t.tax_name === taxName);
              return tax ? tax.tax_value : 0;
            }),
            backgroundColor: this.getDistinctColor(index, taxNames.length),  // Use the custom function for color
            borderColor: this.getDistinctColor(index, taxNames.length),  // Use the custom function for color            
            borderWidth: 1,
            categoryPercentage: 0.5
          };
        });
        this.graphData = {
          datasets: datasets,
          labels: months
    
      }
        }
        this.visible = true
        this.loaderservice.showLoader = false
      }
    })
    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      this.updateColumnHeaders();
    });
   }
   private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column,index) => {
      let data = [
        "month",
        "total",
        "gst",
        "service",
        "other"
      ]
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(`tax_report.column_headers.${data[index]}`);
    });
  }

  ngOnInit(): void {
   
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    })
    this.fromDate.setDate(this.fromDate.getDate() - 365);
    this.fromDate = this.formatDate1(this.fromDate).slice(0,10);
    this.toDate = this.formatDate1(this.toDate).slice(0,10);
    this.loaderservice.showLoader = true
    this.visible = false
    if(this.isEntityForeign == '0'){
      this._apiService.getTaxCollectionReport(this.entityHashId,  this.formatDate1(this.fromDate), this.formatDate1(this.toDate))

    }
    else if(this.isEntityForeign == '1'){
      this._apiService.getInternationalTaxCollectionReport(this.entityHashId,this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
    }


  }
  search(){
       // Ensure date range is valid based on the selected frequency
       const fromDate = new Date(this.fromDate);
       const toDate = new Date(this.toDate);
   
       if (this.selectedFrequency === 1) { // Daily
         const maxRange = 90;
         const range = (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24);
         if (range > maxRange) {
           const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
             data : {
               title : 'Alert',
               message : 'The selected time frame between from date and to date should be under 90 days.',
               okbtn : 'Ok',
               cancelbtn : 'Cancel',
               type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
             },
             disableClose : true
           });
           return;
         }
       } else if (this.selectedFrequency === 2) { // Monthly
         const maxRange = 36;
         const range = (toDate.getMonth() - fromDate.getMonth() + (12 * (toDate.getFullYear() - fromDate.getFullYear())));
         if (range > maxRange) {
           const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
             data : {
               title : 'Alert',
               message : 'The selected time frame between from date and to date should be under 3 years.',
               okbtn : 'Ok',
               cancelbtn : 'Cancel',
               type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
             },
             disableClose : true
           });
           return;
         }
       }
   
       //end
    if(this.selectedFrequency == 2){
      this.tableDisplayColumns = [
        {
          columnName: 'month',
          columnProperty: "month"
        },
        {
          columnName: 'total sales',
          columnProperty: "total_tax"
        },
        {
          columnName: 'GST Collection',
          columnProperty: "gst_collection"
        },
        {
          columnName: 'service tax',
          columnProperty: "service_tax"
        },
        {
          columnName: 'other tax',
          columnProperty: "other_tax"
        },
      ]
      this.loaderservice.showLoader = true
      this.visible = false
      if(this.isEntityForeign == '0'){
        this._apiService.getTaxCollectionReport(this.entityHashId,  this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
  
      }
      else if(this.isEntityForeign == '1'){
        this._apiService.getInternationalTaxCollectionReport(this.entityHashId,this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
      }
    }
    else{
      this.tableDisplayColumns = [
        {
          columnName: 'month',
          columnProperty: "month"
        },
        {
          columnName: 'total sales',
          columnProperty: "total_tax"
        },
        {
          columnName: 'GST Collection',
          columnProperty: "gst_collection"
        },
        {
          columnName: 'service tax',
          columnProperty: "service_tax"
        },
        {
          columnName: 'other tax',
          columnProperty: "other_tax"
        },
      ]
      this.loaderservice.showLoader = true
      this.visible = false
      if(this.isEntityForeign == '0'){
        this._apiService.getTaxCollectionReport(this.entityHashId,  this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
  
      }
      else if(this.isEntityForeign == '1'){
        this._apiService.getInternationalTaxCollectionReport(this.entityHashId,this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
      }
    }
  }

  // changeFrequency(){
  //   if(this.selectedFrequency == 2){
  //     this.tableDisplayColumns = [
  //       {
  //         columnName: 'month',
  //         columnProperty: "month"
  //       },
  //       {
  //         columnName: 'total sales',
  //         columnProperty: "totalSales"
  //       },
  //       {
  //         columnName: 'home sales',
  //         columnProperty: "homeSales"
  //       },
  //       {
  //         columnName: 'shop sales',
  //         columnProperty: "shopSales"
  //       },
  //     ]
  //     this.loaderservice.showLoader = true
  //     this.visible = false
  //     this._apiService.getTaxCollectionReport(this.entityHashId,  this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
  //   }
  //   else{
  //     this.tableDisplayColumns = [
  //       {
  //         columnName: 'date',
  //         columnProperty: "date"
  //       },
  //       {
  //         columnName: 'total sales',
  //         columnProperty: "totalSales"
  //       },
  //       {
  //         columnName: 'home sales',
  //         columnProperty: "homeSales"
  //       },
  //       {
  //         columnName: 'shop sales',
  //         columnProperty: "shopSales"
  //       },
  //     ]
  //     this.loaderservice.showLoader = true
  //     this.visible = false
  //     this._apiService.getTaxCollectionReport(this.entityHashId,  this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
  //   }
  // }
 
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  navigate(){
    this.router.navigate(['../'], {relativeTo: this.route ,  queryParamsHandling: 'preserve'})
  }
 
   
  toShowGraph: boolean = false
  graphData: any
  changeView(){
    if(this.selectedView == 'Data'){
      this.toShowGraph = false
    }else if(this.selectedView == 'Graph'){
      if(this.isEntityForeign == '0'){
        this.graphData = {
          datasets: [
            {
            label: 'GST Collection',
            data: this.taxCollectionReportData.map(item => {
                  return item.gst_collection
              }),
            backgroundColor: this.getDistinctColor(0,3),  // Use the custom function for color
            borderColor: this.getDistinctColor(0,3),  // Use the custom function for color            
            borderWidth: 1,
            categoryPercentage: 0.5
          },
            {
            label: 'Service Tax',
            data: this.taxCollectionReportData.map(item => {
                  return item.service_tax
              }),
            backgroundColor: this.getDistinctColor(1,3),  // Use the custom function for color
            borderColor: this.getDistinctColor(1,3),  // Use the custom function for color            
            borderWidth: 1,
            categoryPercentage: 0.5
          },
            {
            label: 'Other Tax',
            data: this.taxCollectionReportData.map(item => {
                  return item.other_tax
              }),
            backgroundColor: this.getDistinctColor(2,3),  // Use the custom function for color
            borderColor: this.getDistinctColor(2,3),  // Use the custom function for color            
            borderWidth: 1,
            categoryPercentage: 0.5
          },
          ],
          labels: this.taxCollectionReportData.map(item => {
            return item.month
        })
    
      }
      
    this.toShowGraph = true

      }
      else if(this.isEntityForeign == '1'){
        // Prepare the months and tax names
        const months = this.taxCollectionReportData.map(item => item.month);
        const taxNames = this.taxCollectionReportData[0].taxes.map((tax:any) => tax.tax_name);
     
        
        // Prepare datasets for each tax
        const datasets = taxNames.map((taxName:any, index:any) => {
          return {
            label: taxName,
            data: this.taxCollectionReportData.map(item => {
              const tax = item.taxes.find((t:any) => t.tax_name === taxName);
              return tax ? tax.tax_value : 0;
            }),
            backgroundColor: this.getDistinctColor(index, taxNames.length),  // Use the custom function for color
            borderColor: this.getDistinctColor(index, taxNames.length),  // Use the custom function for color            
            borderWidth: 1,
            categoryPercentage: 0.5
          };
        });
        this.graphData = {
          datasets: datasets,
          labels: months
    
      }
      this.toShowGraph = true
      }

    }


    
  }
  getDistinctColor(index: number, total: number) {
    const goldenRatio = 0.61803398875; // Golden ratio for better color distribution
    const hue = (index * goldenRatio * 360) % 360; // Spread colors using golden ratio
    const saturation = 80; // Higher saturation for more vivid colors
    const lightness = 45 + (index % 2) * 10; // Alternating lightness for more contrast
  
    return `hsl(${hue.toFixed(0)}, ${saturation}%, ${lightness}%)`;
  }
  
  convertDateString(dateString:any) {
    // Split the input string to extract the year and month
    const [year, month] = dateString.split('-');

    // Array of month names
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Convert month from string to number and adjust for zero-based index
    const monthIndex = parseInt(month, 10) - 1;

    // Retrieve the month name
    const monthName = monthNames[monthIndex];

    // Return the formatted string
    return `${monthName} ${year}`;
}

formatDate1(dateStr:Date) {

  let curdate = new Date(dateStr).toLocaleString('en-CA', {
    timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' 
}).slice(0, 10);
    console.log(curdate);
    
    return curdate
}


normalizeTaxData(data:any) {
  // Collect all unique tax names
  const allTaxNames = new Set();
  data.forEach((entry:any) => {
      entry.taxes.forEach((tax:any) => {
          allTaxNames.add(tax.tax_name);
      });
  });

  // Convert the set of tax names to an array
  const taxNamesArray = Array.from(allTaxNames);

  // Normalize each entry
  const normalizedData = data.map((entry:any) => {
      // Create a tax map for easy lookup
      const taxMap:any = {};
      entry.taxes.forEach((tax:any) => {
          taxMap[tax.tax_name] = tax.tax_value;
      });

      // Ensure all tax names are present
      const normalizedTaxes = taxNamesArray.map((taxName:any) => ({
          tax_name: taxName,
          tax_value: taxMap[taxName] || 0
      }));

      // Return the normalized entry
      return {
          ...entry,
          taxes: normalizedTaxes
      };
  });

  return normalizedData;

}


// Generate columns dynamically
generateColumns = (data: any[]) => {
  const baseColumns = [
    { columnName: 'Month', columnProperty: 'month' },
    { columnName: 'Total tax', columnProperty: 'total_taxt' },
  ];

  // Get unique tax names from the first record
  const taxColumns = data[0].taxes.map((tax: any) => ({
    columnName: tax.tax_name.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c: string) => c.toUpperCase()), // Format name
    columnProperty: tax.tax_name.toLowerCase(), // Use tax_name as the property key
  }));

  return [...baseColumns, ...taxColumns];
};

// Function to map row data to the appropriate tax columns
mapRowData = (row: any) => {
  // Create a base row with the month
  const rowData: any = {
    month: row.month,
    total_taxt: row.total_taxt
  };

  // Add tax values dynamically to the row
  row.taxes.forEach((tax: any) => {
    rowData[tax.tax_name.toLowerCase()] = tax.tax_value; // Use tax_name as the key to store the value
  });

  return rowData;
};


mergeTaxes(data: any[]): any[] {
  // Iterate through each data object (November 2024, December 2024, etc.)
  return data.map(item => {
    // Create a map to hold merged tax data
    const mergedTaxes:any = {};

    // Loop through each tax and merge them based on the tax name (case-insensitive)
    item.taxes.forEach((tax:any) => {
      const normalizedTaxName = tax.tax_name.toLowerCase();  // Normalize the name to lowercase

      // If the normalized tax name already exists, add the tax value, otherwise initialize it
      if (mergedTaxes[normalizedTaxName]) {
        mergedTaxes[normalizedTaxName].tax_value += tax.tax_value;
      } else {
        mergedTaxes[normalizedTaxName] = {
          tax_name: tax.tax_name,  // Set the original tax name
          tax_value: tax.tax_value
        };
      }
    });

    // Return the item with the merged taxes
    return {
      ...item,
      taxes: Object.values(mergedTaxes)  // Convert the merged taxes object back to an array
    };
  });
}


}


